import React from 'react';
import { object, arrayOf, func, string, oneOfType } from 'prop-types';

export default function SortBy({ items, currentSort, updateSort }) {
    if (!items || !items.length) return null;

    return (
        <div className="sort-by">
            <div className="select-wrapper">
                <div className="FieldLabel hidden">
                    <label htmlFor="listing-sort" className="EditingFormLabel">Sort by</label>
                </div>
                <div className="EditingFormValueCell">
                    <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                        <select
                            id="listing-sort"
                            className="DropDownField form-control"
                            value={currentSort ? JSON.stringify(currentSort) : ''}
                            onChange={e => updateSort(e.target.value ? JSON.parse(e.target.value) : null)}
                        >
                            <option value="">Sort By</option>
                            {items.map(sort => (
                                <option key={sort.label} value={JSON.stringify(sort)}>{sort.label}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );
}

SortBy.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    items: arrayOf(object).isRequired,
    currentSort: oneOfType([string, object]),
    updateSort: func.isRequired
    /* eslint-enable react/no-typos */
};

SortBy.defaultProps = { currentSort: '' };
